import React, { useContext, useEffect, useState } from 'react'
import MatchSearchResultItem from '@Components/MatchComponents/v2/MatchSearchResultItem'
import './index.scss'
import SubmissionFilterSection from '@Components/MatchComponents/v2/SubmissionFilterSection'
import { observer } from 'mobx-react'
import ResultsCardTable from '@Components/Tables/ResultsCardTable'
import Sidebar from '@Components/Sidebars/Sidebar'
import DownloadSidebar from '@Components/Sidebars/DownloadSidebar'
import { SidebarDownloadType } from '@App/enum/sidebar-download-type'
import ModalPortal from '@Components/Popups/ModalPortal'
import Button from '@Components/Buttons/Button'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'
import { useOutletContext } from 'react-router'
import MatchHistorySearchContentHeader from '@Components/MatchComponents/MatchHistory/MatchHistorySearchContentHeader'
import { StoresContext } from '@App/contexts'
import useMatchHistorySearch from '@Scenes/RightsholderScene/MatchHistory/v2/MatchHistorySearch/hooks/useMatchHistorySearch'

const MatchHistorySearch = () => {
    const { matchHistoryStore } = useContext(StoresContext)
    const [sidebarIsOpen, setSidebarIsOpen] = useState<boolean>(false)

    const { isSongwriterHub } = useOutletContext<{ isSongwriterHub: boolean }>()
    const { historyQuery, applyFilters, onChangePage, onChangeLimit } = useMatchHistorySearch(isSongwriterHub)

    const closeSidebar = () => {
        setSidebarIsOpen(false)
    }

    useEffect(() => {
        analyticsSendPage('match_history_search')
    }, [])

    return (
        <div className="match-history-wrapper">
            <MatchHistorySearchContentHeader />
            <SubmissionFilterSection onSearch={applyFilters} />
            {!historyQuery.isFetching && (
                <div className="export-button-row">
                    <Button
                        mainColor
                        type="primary"
                        className="export-search-button"
                        onClick={() => setSidebarIsOpen(true)}
                    >
                        Export
                    </Button>
                </div>
            )}
            <ResultsCardTable
                items={matchHistoryStore.matchSuggestionHistory?.content ?? []}
                count={matchHistoryStore.matchSuggestionHistory?.totalElements ?? 0}
                paginationInfo={matchHistoryStore.matchSuggestionHistoryPagination}
                limit={matchHistoryStore.matchSuggestionHistoryResultsLimit}
                loading={historyQuery.isFetching}
                onChangeLimit={onChangeLimit}
                onChangePage={onChangePage}
                compactCardType={MatchSearchResultItem}
                extendedCardType={MatchSearchResultItem}
                compact
            />
            <ModalPortal isOpen={sidebarIsOpen} onClose={closeSidebar}>
                <Sidebar onClose={closeSidebar}>
                    <DownloadSidebar
                        closeSidebar={closeSidebar}
                        sidebarDownloadType={SidebarDownloadType.MatchHistoryExport}
                    />
                </Sidebar>
            </ModalPortal>
        </div>
    )
}

export default observer(MatchHistorySearch)
